<template>
	<a-modal :title="isUpdate ? '修改签名' : '新增签名'" :width="640" :visible="visible" :confirmLoading="false"
		:maskClosable="false" @ok="handleOk" @cancel="handleCancel">
		<a-spin :spinning="loading">
			<a-form-model ref="adminForm" :model="form" :label-col="{span:6}" :wrapper-col="{span:14}" autoComplete="off">
				<a-form-model-item v-show="false" label="ID" prop="id">
					<a-input type="hidden" v-model.number="form.id" />
				</a-form-model-item>
				<a-form-model-item label="标签名" prop="tag_name"
					:rules="[
						{ required: true, message: '必填，不能为空', trigger: 'blur' },
						{ max: 10, message: '不能超过10个字符', trigger: 'blur' },
						{ validator: isExistTagName, trigger: 'blur' }
					]">
					<a-input v-model="form.tag_name" />
				</a-form-model-item>
				<a-form-model-item label="性别" prop="sex"
					:rules="[{ required: true, message: '必填，不能为空', trigger: 'change' }]">
					<a-select v-model="form.sex" style="width:100px" placeholder="请选择">
						<a-select-option value="MALE">男</a-select-option>
						<a-select-option value="FEMALE">女</a-select-option>
						<a-select-option value="INTERSEX">通用</a-select-option>
					</a-select>
				</a-form-model-item>
			</a-form-model>
		</a-spin>
	</a-modal>
</template>

<script>
	import pick from 'lodash.pick';
	import {
		tagNameIsExist
	} from '@/api/system/tag';

	const fields = ['id', 'tag_name', 'sex'];

	function emptyForm() {
		return {
			id: 0,
			tag_name: '',
			sex: undefined
		};
	}

	export default {
		props: {
			visible: {
				type: Boolean,
				required: true
			},
			loading: {
				type: Boolean,
				default: () => false
			},
			model: {
				type: Object,
				default: () => null
			}
		},
		data() {
			return {
				form: emptyForm(),
			}
		},
		created() {
			this.unwatch = this.$watch('model', (newVal) => {
				if (!newVal) {
					this.initForm();
					return;
				}

				this.$nextTick(() => {
					const base = pick(newVal, fields);
					if (base.tag_name === undefined) {
						base.tag_name = newVal.tagName != null ? newVal.tagName : '';
					}
					this.form = { ...emptyForm(), ...base };
					if (this.$refs.adminForm) {
						this.$refs.adminForm.clearValidate();
					}
				});
			}, {
				immediate: true
			});
		},
		computed: {
			isUpdate: function() {
				return this.model && this.model.id > 0 ? true : false;
			}
		},
		methods: {
			initForm() {
				this.form = emptyForm();
				this.$nextTick(() => {
					if (this.$refs.adminForm) {
						this.$refs.adminForm.clearValidate();
					}
				});
			},
			handleOk() {
				this.$emit('ok');
			},
			handleCancel() {
				this.$emit('cancel');
				this.resetState();
			},
			resetState() {
			},
			isExistTagName(rule, value, callback) {
				if (value === undefined || value === '' || (this.model && (this.model.tagName === value || this.model.tag_name === value))) {
					callback();
					return;
				}
				tagNameIsExist(value).then(res => {
					if (res.data) {
						callback(new Error('标签已存在'));
					} else {
						callback();
					}
				}).catch(() => {
					callback();
				});
			},
		}
	}
</script>

<style scoped>
	.ant-input-number-handler-wrap :deep(.ant-input-number-handler-wrap) {
		display: none;
	}
</style>
